// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EKeN","content":"styles_content__1geXC","row":"styles_row__3yVxb","footer":"styles_footer__2F22q","phraseLength":"styles_phraseLength__FpKf_"};